import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import PublicLayout from "web/components/PublicLayout";
// import Banner from "web/assets/images/fuunders-circle-banner.webp";
// import FeaturedImage from "web/assets/images/featured-fc.jpeg";
// import FeaturedImage from "web/assets/images/Bettway Image.jpg";
import FeaturedImage from "web/assets/images/PalletTrader_FC Member Portraits_Mortimer .webp";
import BackgroudShawdow from "web/assets/images/Ellipse 1091.png";
// import FeaturedImage from "web/assets/images/Bettway-Image_cropped.webp";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import AmbassadorsLogo from "web/assets/images/ambassadors.webp";

import {
  Container,
  Wrapper,
  TextSection,
  Text,
  AmbassadorText,
} from "web/pages/public/landing-page/FoundersCircle/FounderCircleStyled";
import BrandLogos from "./BrandsLogo";
const FoundersCircle = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let history = useHistory();
  return (
    <>
      <Helmet title="PalletTrader | Founders Circle">
        <meta
          name="description"
          content="Discover PalletTrader’s Founders Circle, featuring top pallet companies ready to support your needs with reliable supply and exceptional service."
        />
        <meta name="robots" content="index,follow" />
        <link
          rel="canonical"
          href="https://www.pallettrader.com/founders-circle"
        />
      </Helmet>

      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <TextSection>
              <Text>
                <h2>The Founders Circle.</h2>
                <h3>
                  Our trusted partners, they make us better. They'll make you
                  better, too.
                </h3>
                <p>
                  Our Founders Circle Ambassadors were selected for their
                  capability, expertise, and knowledge. We've known most of them
                  for years, and now we're proud to say they're part of the
                  PalletTrader family. If you choose to do business with them,
                  rest assured they're among the very best our industry has to
                  offer.
                </p>
                {/* <div style={{ postition: "relative" }} onClick={(event) => {
                  event.preventDefault();
                  history.push("/featured-ambassador");
                }}>
                  <div>
                    <AmbassadorText>
                      <div>
                        <h5>-Featured Ambassador-</h5>
                        <h2 style={{ marginTop: "" }}>Mortimer Pallet </h2>
                        <h6 style={{ marginTop: "-9px" }}>Read Their Story</h6>
                      </div>
                    </AmbassadorText>
                  </div>
                  <img className="ambassadors-image" src={FeaturedImage} alt="featured image" role="button"
                    onClick={(event) => {
                      event.preventDefault();
                      history.push("/featured-ambassador");
                    }}

                  />
                </div> */}

                <img
                  className="ambassadors-logo"
                  src={AmbassadorsLogo}
                  alt=""
                />

                <BrandLogos />
              </Text>
            </TextSection>
          </Wrapper>
        </Container>
        <LandingFooter />
      </PublicLayout>
    </>
  );
};

export default FoundersCircle;
